import React from "react";

export const DelecteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none">
      <path
        d="M17 3.09302C17.2652 3.09302 17.5196 3.19837 17.7071 3.38591C17.8946 3.57345 18 3.8278 18 4.09302C18 4.35823 17.8946 4.61259 17.7071 4.80012C17.5196 4.98766 17.2652 5.09302 17 5.09302H16L15.997 5.16402L15.064 18.235C15.0281 18.7396 14.8023 19.2118 14.4321 19.5566C14.0619 19.9014 13.5749 20.093 13.069 20.093H4.93C4.42414 20.093 3.93707 19.9014 3.56688 19.5566C3.1967 19.2118 2.97092 18.7396 2.935 18.235L2.002 5.16502L2 5.09302H1C0.734784 5.09302 0.48043 4.98766 0.292893 4.80012C0.105357 4.61259 0 4.35823 0 4.09302C0 3.8278 0.105357 3.57345 0.292893 3.38591C0.48043 3.19837 0.734784 3.09302 1 3.09302H17ZM13.997 5.09302H4.003L4.931 18.093H13.069L13.997 5.09302ZM11 0.0930176C11.2652 0.0930176 11.5196 0.198374 11.7071 0.385911C11.8946 0.573447 12 0.827801 12 1.09302C12 1.35823 11.8946 1.61259 11.7071 1.80012C11.5196 1.98766 11.2652 2.09302 11 2.09302H7C6.73478 2.09302 6.48043 1.98766 6.29289 1.80012C6.10536 1.61259 6 1.35823 6 1.09302C6 0.827801 6.10536 0.573447 6.29289 0.385911C6.48043 0.198374 6.73478 0.0930176 7 0.0930176H11Z"
        fill="#FF0000"
      />
    </svg>
  );
};
